export const COMPANY_SHOW_RESET = 'COMPANY_SHOW_RESET'
export const COMPANY_SHOW_SET_ERROR = 'COMPANY_SHOW_SET_ERROR'
export const COMPANY_SHOW_SET_RETRIEVED = 'COMPANY_SHOW_SET_RETRIEVED'
export const COMPANY_SHOW_TOGGLE_LOADING = 'COMPANY_SHOW_TOGGLE_LOADING'
export const COMPANY_SHOW_SET_CONTACTS = 'COMPANY_SHOW_SET_CONTACTS'
export const COMPANY_SHOW_SET_ADDRESSES = 'COMPANY_SHOW_SET_ADDRESSES'
export const COMPANY_SHOW_SET_DOCUMENTS = 'COMPANY_SHOW_SET_DOCUMENTS'
export const COMPANY_SHOW_SET_COMPANY_PRODUCTS = 'COMPANY_SHOW_SET_COMPANY_PRODUCTS'
export const COMPANY_SHOW_SET_POSITION = 'COMPANY_SHOW_SET_POSITION'



// WEBPACK FOOTER //
// ./src/store/modules/company/show/mutation_types.js